import React, { useEffect, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Dialog, Box, Typography, Paper, DialogContent} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Spottable from '@enact/spotlight/Spottable/Spottable';
import { useSelector } from 'react-redux';
import { baseAuthUrl } from "../authProvider";
import { useTranslate } from 'react-admin';
import CloseButton from '../CustomizedUIs/CloseButton';
import { getUri } from '../utils';

const useStyles = makeStyles(theme => ({
    dialogCloseBtn: {
        width: '25px',
        height: '25px',
        borderRadius: '10px',
        border: ' solid 2px #e5f1f8',
        backgroundColor: ' #ffffff',
        marginLeft: 10,
        marginRight: 10,


    },
    textTitle: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '21.6px',
        letterSpacing: 'normal',
        color: '#4f5064',
        marginTop: 10,
    },
    MuiGridItem: {
        padding: '5px 17px',
        maxWidth: 450,
        borderRadius: 0
    },
    MuiGridContainer: {
        paddingLeft: '50px !important',
        paddingRight: '50px !important'
    },
    MuiTypography: {
        fontFamily: 'UniviaPro-Medium',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'

    },
    menu: {
        padding: theme.spacing(2),
        '&:focus': {
            outline: 'none',
            border: '12px solid black',
            padding: theme.spacing(0.5)//'4px 16px'
        }
    },
    paper: {
        textAlign: 'center',
        color: '#fff',
    },
    img: {
        maxHeight: '180px',
        maxWidth: '100%',
        paddingBottom: '5px',
        '&:focus': {
            outline: 'none',
            border: '10px solid black',
            padding: theme.spacing(0.5)
        }
    },
    instructionImg: {
        maxHeight: '180px',
        maxWidth: '100%',
        '&:focus': {
            outline: 'none',
            border: '10px solid black',
            padding: theme.spacing(0.5)
        }
    },
    iconMenu: {
        width: 150,
        height: 150
    },
    toolbar: {
        height: '100%',
        padding: '2vh 3vh'
    },
    clock: {
        color: '#000',
        marginRight: '3vh'
    },
    spacer: {
        flex: 1,
    },
    MuiTypographyWhite: {
        fontFamily: 'UniviaPro-Medium',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        color: '#000000'
    },
    MuiTypographyVersion: {
        position: 'absolute',
        right: '0',
        top: '3vh',
        marginRight: '20px',
    },
    bottomLogo: {
        paddingBottom: '3vh',
        maxWidth: '30vh',
        paddingRight: '12vh'
    },
    Dialog: {
        minHeight: '60vh',
        minWidth: '60vh'
    },
    closeBtn: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '10px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.4px',
        color: '#4f5064',
    },
    dyslexieFont: {
        fontFamily: 'Dyslexie',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    },
    dyslexieFontWhite: {
        fontFamily: 'Dyslexie',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        color: '#000000'
    }
}));


const DateTime = props => {
    const classes = useStyles();
    const hours = new Date().getHours()
    const minutes = new Date().getMinutes()
    const date = new Date().getDate()
    const month = new Date().getMonth() + 1
    const year = new Date().getFullYear()
    const [time, setTime] = useState({
        date: year + "-" + (month < 10 ? '0' + month : month) + '-' + (date < 10 ? '0' + date : date),
        time: (hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 ? '0' + minutes : minutes),
        fistLoad: false
    });
    return (
        <Fragment>
            <Box {...props}>
                <Typography color="inherit" variant="h2" className={props.data.dyslexie ? classes.dyslexieFont : classes.MuiTypography}>{time.time !== '' ? time.time : null}</Typography>
            </Box>
            <Box {...props}>
                <Typography color="inherit" variant="h4" className={props.data.dyslexie ? classes.dyslexieFont : classes.MuiTypography}>{time.date !== '' ? time.date : null}</Typography>
            </Box>
            <Box {...props}>
                <Typography color="inherit" variant="h4" className={(props.data.dyslexie ? classes.dyslexieFont : classes.MuiTypography) + ' ' + classes.MuiTypographyVersion}>102.200817468</Typography>
            </Box>
        </Fragment>
    )
}

const useOtherStyle = makeStyles({

    backGroundImage: ({ url }) => ({
        backgroundImage: `url('${baseAuthUrl}/media/${url.fd}')`,
        backgroundPosition: 'center',
        backgroundRepeat: ' no-repeat',
        backgroundSize: 'cover',
        minHeight: '80vh',
        border: 'solid 10px #e6e6eb'
    })
});

function DialogPreview({ open, onClose }) {
    const translate = useTranslate();
    const classes = useStyles();
    const [dataMain, setDataMain] = useState([])
    const [treeChildren, setTreeChildren] = useState([])
    const MySpottableComponent = Spottable({ emulateMouse: false }, Paper);
    const { tree, nodeSelected, saveInfoPage } = useSelector(state => state.tree);
    const nodeMain = isNaN(nodeSelected.id) ? nodeSelected.id : parseInt(nodeSelected.id);
    const url = !dataMain.backgroundImage ? '' : dataMain.backgroundImage;
    const classes2 = useOtherStyle({ url });
    const onPreview = () => {
        const recursive = (array = []) => {
            var node = array.id
            for (let j = 0; j < array.children.length; j++) {
                if (array.children[j].id === nodeMain) {
                    return node
                }
            }

        }

        for (let i = 0; i < tree.length; i++) {
            if (tree[i].children[0].id === nodeMain) {
                setDataMain(tree[i].children[0].data)
                setTreeChildren(tree[i].children[0].children)
            }
            else {
                for (let k = 0; k < tree.length; k++) {
                    const mainId = recursive(tree[k].children[0])
                    const nodeId = tree[k].children[0].id
                    if (nodeId === mainId) {
                        if (tree[k].children[0].id === nodeId) {
                            setDataMain(tree[k].children[0].data)
                            setTreeChildren(tree[k].children[0].children)
                        }
                        break
                    }
                }
            }
        }
    }
    // const localurl = getUri(window.location.href);
    // //const AuthURL = baseAuthUrl.slice(-5)
    // //const URL = baseAuthUrl.split(AuthURL)
    // const URL = (localurl.schema || 'http') + '://' + localurl.domain + ':' + localurl.port;
    //const _authURL = getUri(baseAuthUrl);
    const URL = process.env.REACT_APP_BASE_PREVIEW_URL;//_authURL.scheme + '://' + _authURL.domain;
    //const URL = _authURL.scheme + '://' + _authURL.domain + (_authURL.port !== -1? ':' + _authURL.port: '') + '/admin';//baseAuthUrl.split(AuthURL)
    console.log('TVPreview Link:', URL);
    useEffect(() => {
        onPreview();
    }, [tree, nodeSelected, nodeMain]);

    return (
        <Dialog fullScreen open={open} id="dialogPreviewSchedulePopup" classes={{ paper: classes.Dialog }}>
            <Box display='flex' justifyContent='flex-end' alignItems='center' mr={2} mt={1}>
                <Box style={{ marginRight: 'auto', marginLeft: 40 }} >
                    <Typography className={classes.textTitle}>{translate('pos.common.previewInfoPage')}</Typography>
                </Box>
                <Typography className={classes.closeBtn}>{translate(`pos.user.close`)}</Typography>
                <CloseButton onClick={onClose}/>
            </Box>
            {/* <Box display='flex' justifyContent='flex-end' alignContent='center' mr={2} mt={2}>
                <Box style={{ marginRight: 'auto', marginLeft: 40, marginTop: 34 }} >
                    <Typography className={classes.textTitle}>{translate('pos.common.previewInfoPage')}</Typography>
                </Box>
                <Typography variant='subtitle2'>{translate(`pos.user.close`)}</Typography>
                <IconButton size='small' className={classes.dialogCloseBtn} onClick={onClose}>
                    <Close color='primary' />
                </IconButton>
            </Box> */}
            <DialogContent>
                <iframe frameBorder={0} style={{ height: "90vh", width: "100%" }} src={`${URL}/TVPreview/?serial_number=${saveInfoPage.id}`}></iframe>
                {/* <Box alignItems='center' justifyContent='center' className={classes2.backGroundImage}> */}
                {/* <Box>
                        <Toolbar className={classes.toolbar}>
                            <DateTime className={classes.clock} data={dataMain} />
                        </Toolbar>
                    </Box>
                    <Box display='flex' alignItems='center' justifyContent='center' style={{ width: 1350, height: 400, marginTop: 30 }}>
                        <Grid item xs={12}>
                            <Grid container className={classes.MuiGridContainer}>
                                {
                                    treeChildren.map((menu, index) => {
                                        if (index < 6) {
                                            const iconMenu = menu.applicationData.preview && menu.applicationData.preview.icon ?
                                                menu.applicationData.preview.icon.fd : null
                                            return (
                                                menu && menu.applicationData.nodeType &&
                                                <Grid key={index} item xs={4} className={classes.MuiGridItem}>
                                                    <MySpottableComponent

                                                        className={classes.menu} tabIndex={index}
                                                        style={{ background: menu.applicationData.preview ? menu.applicationData.preview.color : '#fff', borderRadius: 0 }}
                                                    >
                                                        <Box className={classes.paper} style={{ color: `${(!menu.applicationData.preview || menu.applicationData.preview.color === '') ? '#000' : '#fff'}` }}>
                                                            <Box height={150} pb='2px'>
                                                                {iconMenu && <img src={`${baseAuthUrl}/media/${iconMenu}`} className={`${classes.img} ${classes.iconMenu}`} />}
                                                            </Box>
                                                            <Typography color="inherit" variant="h3"
                                                                className={menu.applicationData.preview && menu.applicationData.preview.color !== '#ffffff' ? (dataMain.dyslexie ? classes.dyslexieFont : classes.MuiTypography) : (dataMain.dyslexie ? classes.dyslexieFontWhite : classes.MuiTypographyWhite)}>
                                                                {menu.applicationData.preview && menu.applicationData.preview.name !== '' ?
                                                                    menu.applicationData.preview.name : 'EMPTY'}</Typography>
                                                        </Box>
                                                    </MySpottableComponent>
                                                </Grid>
                                            )
                                        }
                                    })
                                }
                            </Grid>
                        </Grid>
                    </Box>
                    <Box mt={7}>
                        <Grid item xs={12} container justify="space-between" alignItems="flex-end">
                            <Grid item >
                                <Box style={{ marginLeft: 100 }}>
                                    {dataMain.instructionFeatureImage && (<img alt="" src={`${baseAuthUrl}/media/${dataMain.instructionFeatureImage.fd}`}
                                        className={classes.instructionImg} />)}
                                </Box>
                            </Grid>
                            <Grid item >
                                <Box className={classes.bottomLogo}>
                                    {dataMain.logoType && <img alt="" src={`${baseAuthUrl}/media/${dataMain.logoType.fd}`} className={classes.img} />}
                                </Box>
                            </Grid>
                        </Grid>
                    </Box> */}
                {/* </Box> */}

            </DialogContent>
        </Dialog>
    );
}

DialogPreview.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default DialogPreview;
